/**
  * @function evalute - evaluate formUniqueIdentifierBehavior
  */
const _require = require('@truqc/content-path'),
  getContentValue = _require.getContentValue;
const getMax = forms => {
  // not good, this is a duplicate. we need to create a new unique identifier
  let max = -1;
  forms.forEach(val => {
    const uniqueID = getContentValue('/uniqueIdentifier', val.content);
    if (uniqueID !== undefined && max < uniqueID) {
      max = uniqueID;
    }
  });
  if (max === -1) {
    max = 0;
  }
  return max;
};
const hasDuplicate = (forms, formID, uniqueIdentifier) => {
  // look for duplicates
  const index = forms.findIndex(val => {
    const uniqueID = getContentValue('/uniqueIdentifier', val.content);
    if (formID === val.id) {
      // skip self.  only look for other forms with same uniqueIdentifier
      return false;
    }
    if (uniqueID === uniqueIdentifier) {
      return true;
    }
    return false;
  });

  // if index is defined on another form, we found a duplicate unique ID,
  // which can happen is IOS is offline.
  return index !== -1;
};
const generateUniqueFormIdentifier = function generateUniqueFormIdentifier(formID, formContent) {
  let forms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const uniqueIdentifier = getContentValue('/uniqueIdentifier', formContent);
  let newUniqueIdentifer = uniqueIdentifier;
  if (uniqueIdentifier === undefined) {
    // uniqueIdentifier was not initialized yet.
    newUniqueIdentifer = getMax(forms) + 1;
  }
  if (uniqueIdentifier !== undefined && hasDuplicate(forms, formID, uniqueIdentifier)) {
    newUniqueIdentifer = getMax(forms) + 1;
  }
  return newUniqueIdentifer;
};
const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const clientInfo = await sourceEvaluator({
    type: 'clientInfoBehavior'
  }, content, parentContentPath, transientContext, nativeFunctions);
  // --- on non-web ...
  // if not on web, run the behavior
  const uniqueIdentifier = await sourceEvaluator(source.uniqueIdentifier);
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  const formID = getContentValue('/id', content);
  if (!formID || !formTypeIdentifier) {
    return undefined;
  }
  let newUniqueIdentifer;
  // do different things on web, server and ios...
  if (clientInfo.clientType === 'web') {
    if (uniqueIdentifier !== undefined) {
      // should not happen, but if run after create...
      return uniqueIdentifier;
    }
    const performSource = {
      type: 'performOnServerBehavior',
      actions: [source]
    };
    // run this behavior on the server to get a new unique identifier.
    const evalResults = await sourceEvaluator(performSource);
    if (evalResults.length > 0) {
      newUniqueIdentifer = evalResults[0];
    }
    return newUniqueIdentifer;
  }

  // on server and ios, get forms.
  const forms = await sourceEvaluator({
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['formType/identifier', 'content'],
    equals: {
      'formType/identifier': formTypeIdentifier
    }
  });
  if (!Array.isArray(forms)) {
    return undefined;
  }
  // mutate - parse JSON.
  forms.forEach(val => {
    if (typeof val.content === 'string') {
      // eslint-disable-next-line no-param-reassign
      val.content = JSON.parse(val.content);
    }
  });
  return generateUniqueFormIdentifier(formID, content, forms);
};
module.exports = {
  evaluate
};